import { tJosa } from '@mathflat/shared/i18n/tJosa'
import type { ReactNode } from 'react'

import Button from '@/component/atoms/Button/Button/Button'
import { Loader } from '@/component/atoms/Loader'
import ModalTemplate from '@/component/templates/ModalTemplate'

import { SCHEDULE_LIST_STRINGS } from '../_constants/scheduleStrings'
import S from './PendingScheduleGate.style'

type Props = {
  status: 'loading' | 'error' | 'ready'
  onRetry: () => void
  children: ReactNode
}

/**
 * 이 학습지의 대기 예약을 먼저 읽어야 초기 오른쪽 목록·토글 상태를 정할 수 있다.
 * 조회가 끝나기 전에는 같은 크기의 껍데기를, 실패하면 다시 시도를 보여주고 본체는 그리지 않는다
 */
const PendingScheduleGate = ({ status, onRetry, children }: Props) => {
  if (status === 'ready') return <>{children}</>

  return (
    <ModalTemplate
      css={S.modal}
      header={
        <header css={S.header}>
          <h3>{`학습지 ${tJosa('출제')}하기`}</h3>
        </header>
      }
      body={
        <div css={S.body}>
          {status === 'error' ? (
            <>
              <p>{SCHEDULE_LIST_STRINGS.loadFailed}</p>
              <Button size="s" variant="outline" color="neutral" onClick={onRetry}>
                {SCHEDULE_LIST_STRINGS.retry}
              </Button>
            </>
          ) : (
            <Loader />
          )}
        </div>
      }
      footer={<footer />}
    />
  )
}

export default PendingScheduleGate
